import React, { Component } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'

export default function withRouter(Component) {
    return function (props) {
        const push = useNavigate()
        const match = useParams()
        const location = useLocation()
        return <Component {...props} {...{ push, match, location }} />
    }
}
